import { FC, useCallback, useMemo } from "react";
import { OnFailure, OnSuccess, RedirectionSideEffect, Record, SaveContext, TransformData, usePickSaveContext, useSaveContext } from 'ra-core'
import chainOptions from "@/utils/chainOptions";

// we modified Ra's SaveContextProvider, so declare-time callbacks and call-time callbacks
// are not an either-or relationship; 
// here declare-time and call-time callbacks are merged, they both get called when response is handled.
const SaveContextProvider: FC<{ value: any }> = ({ children, value }) => {
  const ctrls = usePickSaveContext(value)
  const newValue = useMemo(() => {
    const { save, onSuccessRef, onFailureRef, ...rest } = ctrls
    const newSave = (record: Partial<Record>, redirect: RedirectionSideEffect, callbacks?: {
        onSuccess?: OnSuccess | undefined;
        onFailure?: OnFailure | undefined;
        transform?: TransformData | undefined;
    } | undefined) => {
      save && save(record, redirect, chainOptions(callbacks, {
        ...(onSuccessRef?.current && { onSuccess: onSuccessRef.current }),
        ...(onFailureRef?.current && { onFailure: onFailureRef.current }),
      }))
    };
    return { save: newSave, onSuccessRef, onFailureRef, ...rest }
  }, [ctrls])

  return (
    <SaveContext.Provider value={newValue}>{children}</SaveContext.Provider>
  )
}

export default SaveContextProvider;

export const useSimpleSaveAction = () => {
  const { save } = useSaveContext()
  return useCallback((record: Partial<Record>, callbacks?: any) => {
    save && save(record, '', callbacks)
  }, [save])
}
